import { render, staticRenderFns } from "./LaptopImage.vue?vue&type=template&id=328fa49a&"
import script from "./LaptopImage.vue?vue&type=script&lang=js&"
export * from "./LaptopImage.vue?vue&type=script&lang=js&"
import style0 from "./LaptopImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports